
import { useKanbanTasksApi, parseFilterParams } from '@pages/tasks-kanban'
import { AppRoute, TasksKanbanTeam } from '@shared/config'

import { defineNuxtRouteMiddleware } from '#app'

const teamByRoute: Record<string, TasksKanbanTeam> = {
  [AppRoute.TasksKanbanSupport]: TasksKanbanTeam.Support,
  [AppRoute.TasksKanbanSuccess]: TasksKanbanTeam.Success,
  [AppRoute.TasksKanbanBilling]: TasksKanbanTeam.Billing,
}

export default defineNuxtRouteMiddleware((to) => {
  const team = teamByRoute[to.path]

  if (!team) return

  const params = parseFilterParams(to.query)

  void useKanbanTasksApi({ team, params })
})
